import { type ReactNode } from "react";

import ElectricCarIcon from "@mui/icons-material/ElectricCar";
import EvStationIcon from "@mui/icons-material/EvStation";
import LocalGasStationIcon from "@mui/icons-material/LocalGasStation";
import { Box } from "@mui/material";

import { dealerActiveAuctionSearchFiltersAtom } from "@/src/state/dealer/dealerActiveAuctionSearchFiltersAtom";

import FilterChip from "@/src/components/atoms/FilterChip";

import { VehicleType } from "@/src/pages/dealer/components/VehicleCheckBoxGroup/VehicleCheckBoxGroup";

import { PowerTypeQuickFilter } from "@/src/constants/vehicle";
import { useGetFuelTypes } from "@/src/queries/dealer/getSearchFilters";

import {
  getVisibleBuckets,
  isBucketActive,
  toggleBucket
} from "./powerTypeQuickFilters.lib";

import { useAtom } from "jotai";

const POWER_TYPE_ICONS: Record<PowerTypeQuickFilter, ReactNode> = {
  Bensiini: <LocalGasStationIcon />,
  Sähkö: <ElectricCarIcon />,
  Hybridi: <EvStationIcon />
};

interface PowerTypeQuickFiltersProps {
  selectedVehicles: VehicleType[];
}

const PowerTypeQuickFilters = ({
  selectedVehicles
}: PowerTypeQuickFiltersProps) => {
  const [searchFilters, setSearchFilters] = useAtom(
    dealerActiveAuctionSearchFiltersAtom
  );
  const { data: rawFuelTypes = [] } = useGetFuelTypes(
    selectedVehicles,
    searchFilters
  );

  if (selectedVehicles.length !== 1) return null;

  const buckets = getVisibleBuckets(rawFuelTypes);

  if (buckets.length === 0) return null;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        gap: [1, 1.5],
        width: ["100%", "auto"]
      }}
    >
      {buckets.map((bucket) => (
        <FilterChip
          key={bucket}
          label={bucket}
          icon={POWER_TYPE_ICONS[bucket]}
          isChecked={isBucketActive(bucket, searchFilters?.fuelType)}
          onToggle={() =>
            setSearchFilters((prev) => ({
              ...prev,
              fuelType: toggleBucket(bucket, rawFuelTypes, prev?.fuelType)
            }))
          }
        />
      ))}
    </Box>
  );
};

export default PowerTypeQuickFilters;
